/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplyUserPasswordResetRequest
 */
export interface ApplyUserPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyUserPasswordResetRequest
     */
    newPassword: string;
}

export function ApplyUserPasswordResetRequestFromJSON(json: any): ApplyUserPasswordResetRequest {
    return ApplyUserPasswordResetRequestFromJSONTyped(json, false);
}

export function ApplyUserPasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyUserPasswordResetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newPassword': json['newPassword'],
    };
}

export function ApplyUserPasswordResetRequestToJSON(value?: ApplyUserPasswordResetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newPassword': value.newPassword,
    };
}


